import React from 'react';
import {connect} from 'react-redux';
import Moment from 'react-moment';
import { getSafe } from '../../helpers/utils';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import BooleanToString from '../../helpers/BooleanToString';

function CarPreview ({ guest, currentLanguage }) {

	const langCode = currentLanguage?.code ? currentLanguage.code : 'en';

	return (
		<>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="car-reg-number" fallback="Car Registration #" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					{getSafe(() => guest.car.car_registration_number, 'n/a')}
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="regpreview-need-parking" fallback="Need parking" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<BooleanToString condition={guest.car.need_parking}/>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="car-arrival-date" fallback="Arrival Date" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.car.arrival_date, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="car-arrival-time" fallback="Arrival Time" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.car.arrival_time, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="car-departure-date" fallback="Departure Date" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.car.departure_date, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="car-departure-time" fallback="Departure Time" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.car.departure_time, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="word-comments" fallback="Comments"/></label>
				</div>
				<div className="col-lg-8 col-12">
					{getSafe(() => guest.car.comments, 'n/a')}
				</div>
			</div>
		</>
	)
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(CarPreview);
